const parseOverlayConfig = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value === "string" && value.trim()) {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

export const isExactPdfTemplate = (template) =>
  template?.templateMode === "exact_pdf" && Boolean(template?.sourcePdfRef);

export const exactTemplateSummary = (template) => {
  const overlays = parseOverlayConfig(template?.overlayConfig);
  return {
    exact: isExactPdfTemplate(template),
    mappedVariables: overlays.filter((item) => item?.variableId).length,
  };
};

export const exactTemplateOverlays = (template) => parseOverlayConfig(template?.overlayConfig);

export default isExactPdfTemplate;


export const exactRenderEndpoint = (target, templateId) => {
  const base = target === "attendee" ? "/attendee-management" : "/student-management";
  return `${base}/document-templates/${templateId}/render-exact`;
};


export const makeExactTemplateEditable = (template, content) => ({
  ...(template || {}),
  templateMode: "html",
  sourcePdfRef: null,
  overlayConfig: [],
  content: String(content || ""),
  _sourceRevision: Date.now(),
});
